<template>
    <div class="col-4 p-1" v-for="(option, key) in sortOptions" :key="key" @click="selectOption(option)">
        <div :class="{ 'active-eligibility-bg': option.active, 'eligibility-bg': !option.active }" class="p-2">
            <div class="title">{{ $t(option.label) }}</div>

            <div class="amount">{{ formatCurrency(getSortedOffers(option.field)?.loan_amount.formatted) }}</div>

            <!--desktop-->
            <div class="repayment d-none d-md-block">
                {{ formatCurrency(getSortedOffers(option.field)?.monthly_repayment_display) }}
                {{
                    $t('results.loanTerm', {
                        termDisplay:
                            getSortedOffers(option.field)?.term_display !== undefined
                                ? getSortedOffers(option.field)?.term_display
                                : 'open',
                    })
                }}
            </div>

            <!--mobile-->
            <div class="repayment d-md-none">
                {{ formatCurrency(getSortedOffers(option.field)?.monthly_repayment_display) }}
                ({{
                    $t('results.loanTermRange', {
                        termDisplay:
                            getSortedOffers(option.field)?.term_display !== undefined
                                ? getSortedOffers(option.field)?.term_display
                                : 'open',
                    })
                }})
            </div>

            <div class="apr">
                {{ formatPercentage(getSortedOffers(option.field)?.apr_display.formatted) }}
                APR
            </div>
        </div>
    </div>
</template>

<script>
import { formatPercentage, formatCurrency } from '@js/utilities/number.js'
import { mapGetters, useStore } from 'vuex'

// lodash components
import find from 'lodash/find'

export default {
    props: {
        sortOptions: {
            default: [],
        },
    },
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        ...mapGetters(['getFirstOrderedOfferByField']),
        territory: function () {
            return process.env.TERRITORY
        },
    },
    methods: {
        formatPercentage: formatPercentage,
        formatCurrency: formatCurrency,
        activeOption() {
            return find(this.sortOptions, function (option) {
                return option.active
            })
        },
        selectOption: function (option) {
            const activeOption = this.activeOption()

            activeOption.active = false
            option.active = true

            this.trackEvent('results_element_click', {
                territory: this.territory,
                store: this.store,
                sortCategory: option.name,
                elementType: 'button',
                elementName: option.field === false ? 'eligibility' : option.field,
                sortTypeClicked: option.name,
                sortPopUp: null,
            })
        },
        getSortedOffers: function (key) {
            const sortedOffers = {}
            const optionField = key === false ? 'eligibility' : key
            sortedOffers[optionField] = this.getFirstOrderedOfferByField(optionField)

            return sortedOffers[optionField]
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/variables';
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.col-4.p-1 {
    display: flex;
    flex-direction: column;
}

.col-4.p-1 > div {
    flex: 1;
}
</style>
